<div fxLayout="row">
  <div fxFlex="93">
    <h1>{{ data.LastName }} {{ data.FirstName }}</h1>
    <h2>{{ data.Title | translate }}</h2>
  </div>
  <div fxFlex="7">
    <button mat-icon-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutGap="10px">
  <form [formGroup]="formGroup">
    <app-legalization-file-type-selector
      [disabled]="data.IsCorrection"
      [selectedTypeId]="selectedDocument?.LegalizationDocumentTypeId"
      (typeSelected)="onLegalizationDocumentTypeSelected($event)">
    </app-legalization-file-type-selector>

    @if (description.value) {
      <mat-form-field appearance="outline" fxFill class="readonly-field">
        <mat-label>{{ 'Legalization.DocumentDescription' | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="description"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          readonly
        ></textarea>
      </mat-form-field>
    }

    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field fxFlex="50" appearance="outline">
        <mat-label>{{ 'Legalization.StartDate' | translate }}</mat-label>
        <input
          matInput
          [matDatepicker]="startDatePicker"
          formControlName="startDate"
          autocomplete="date"
          [matDatepickerFilter]="documentStartDateFilter"
          />
          <mat-datepicker-toggle [for]="startDatePicker" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker startView="multi-year"></mat-datepicker>
          @if (!startDate || (startDate.invalid && startDate.touched)) {
            <mat-error>
              {{ 'InvalidField' | translate }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>{{ 'Legalization.EndDate' | translate }}</mat-label>
          <input
            matInput
            [matDatepicker]="endDatePicker"
            formControlName="endDate"
            autocomplete="date"
            [matDatepickerFilter]="documentEndDateFilter"
            />
            <mat-datepicker-toggle [for]="endDatePicker" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker startView="multi-year"></mat-datepicker>
            @if (!endDate || (endDate.invalid && endDate.touched)) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
          <mat-form-field fxFlex="50" appearance="outline">
            <mat-label>{{ 'Legalization.DocumentNumber' | translate }}</mat-label>
            <input
              matInput
              type="text"
              formControlName="documentNumber"
              />
              @if (documentNumber.invalid && documentNumber.touched) {
                <mat-error>
                  {{ 'InvalidField' | translate }}
                </mat-error>
              }
            </mat-form-field>
          </div>

          <mat-form-field appearance="outline" fxFill>
            <mat-label>{{ 'Legalization.Comment' | translate }}</mat-label>
            <textarea
              matInput
              [maxLength]="300"
              cdkTextareaAutosize
              #autosize="cdkTextareaAutosize"
              formControlName="comment"
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="5"
            ></textarea>
            @if (comment.invalid && comment.touched) {
              <mat-error>
                {{ 'InvalidField' | translate }}
              </mat-error>
            }
          </mat-form-field>
          <div>
            <mat-radio-group formControlName="documentCategory" required>
              <mat-radio-button value="1">{{ 'Legalization.StayLegalization' | translate }}</mat-radio-button>
              <mat-radio-button value="2">{{ 'Legalization.WorkLegalization' | translate }}</mat-radio-button>
              <mat-radio-button value="3">{{ 'Legalization.StayAndWorkLegalization' | translate }}</mat-radio-button>
            </mat-radio-group>
          </div>

          @if (this.data.WorkerId) {
            <app-agreements-section
              [workerId]="data.WorkerId"
              [preSelectedAgreements]="preSelectedAgreementsArray"
              (agreementsSelectionChange)="onAgreementsSelectionChange($event)"
              [disabled]="data.IsCorrection">
            </app-agreements-section>
          }
        </form>
        <div fxFill>
          <fileUpload [maxFileCount]="maxFileCount$ | async" (onFilesChange)="onFilesChange($event)"></fileUpload>
        </div>

        <div class="header-wrapper"></div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
          <button mat-raised-button (click)="onClose()">
            {{ 'Cancel' | translate }}
          </button>
          <button mat-raised-button color="primary" (click)="createLegalizationDocument()" [disabled]="!isSendWorkerFileButtonEnabled()">
            {{ 'Save' | translate }}
          </button>
        </div>
      </div>
